// extracted by mini-css-extract-plugin
export default {"link":"yD-z","disabled":"zD-z"};